<template>
  <div class="flex justify-center items-center h-full">
    <div class="bg-white shadow-xl" v-if="practicePeriod">
        <div class="bg-gray-600 text-white p-4 text-lg font-bold">
          Rediger praksisperiode <span v-if="electionPeriod">({{ electionPeriod.name }})</span>
        </div>
        <form @submit.prevent="doSubmit" class="p-10">
          <div class="flex items-center justify-between mt-6">
            <label for="name" class="font-bold">Navn</label>
            <input type="text" id="name" v-model="practicePeriod.name" placeholder="F.eks. 'Vår 2020 Bachelor'" ref="name" class="ml-6 w-64" required :class="{'invalid': errors['Name'] }">
          </div>
          <div class="flex items-center justify-between mt-6">
            <label for="name" class="font-bold">Studie</label>
            <select v-model="practicePeriod.study" required>
              <option :value="0">Bachelor</option>
              <option :value="1">Master</option>
            </select>
          </div>
          <div class="flex items-center justify-between mt-6" :class="{ 'invalid-input': !isDateRangeValid }">
            <label for="from" class="font-bold">Fra</label>
            <date-picker v-model="practicePeriod.from" placeholder="Velg fra dato"></date-picker>
          </div>
          <div class="flex items-center justify-between mt-6" :class="{ 'invalid-input': !isDateRangeValid }">
            <label for="to" class="font-bold">Til</label>
            <date-picker v-model="practicePeriod.to" placeholder="Velg til dato"></date-picker>
          </div>
          <div class="flex items-center justify-between mt-6">
            <label for="comment" class="font-bold">Fritekst</label>
            <input type="text" id="comment" v-model="practicePeriod.comment" class="ml-6 w-64">
          </div>
          <div class="text-center mt-12">
            <router-link class="btn w-32 mx-2" to="/pk/praksisperioder">Avbryt</router-link>
            <button type="submit" class="btn btn-primary w-32 mx-2" :disabled="!isValid">Lagre</button>
          </div>
        </form>
    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'pk-practiceperiod-edit',
  props: {
    id: {
      type: Number,
      required: true,
    }
  },
  data () {
    return {
      electionPeriod: null,
      practicePeriod: null,
      errors: {},
    }
  },
  computed: {
    isDateRangeValid () {
      if (this.practicePeriod && this.practicePeriod.from !== null && this.practicePeriod.to !== null) {
        return this.practicePeriod.from < this.practicePeriod.to
      }
      return true
    },
    isValid () {
      return this.practicePeriod &&
             (this.practicePeriod.from !== null &&
              this.practicePeriod.to !== null &&
              this.isDateRangeValid &&
              this.practicePeriod.name !== '')
    }
  },
  methods: {
    async doSubmit () {
      const response = await api.pk.updatePracticePeriod(this.practicePeriod)
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$router.push('/pk/praksisperioder')
      }
    },
    onCancel () {
      this.$router.back()
    }
  },
  async created () {
    this.electionPeriod = await api.pk.getElectionPeriod()
    this.practicePeriod = await api.pk.getPracticePeriod(this.id)
    this.$nextTick(() =>  this.$refs.name.focus()) // ref in inside a v-if'
  }
}
</script>

